import { Button } from "@portal/BaseComponents/Button/AntButton";
import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { Col, Row } from "@portal/BaseComponents/Grid/AntGrid";
import { HideWrapper } from "@portal/BaseComponents/HideWrapper/HideWrapper";
import { notify } from "@portal/BaseComponents/Notifications";
import { PopConfirm } from "@portal/BaseComponents/PopConfirm/AntPopConfirm";
import { PopConfirmContent } from "@portal/BaseComponents/PopConfirm/PopConfirmContent";
import { ToolTip } from "@portal/BaseComponents/ToolTip/AntTooltip";
import { TypographyText } from "@portal/BaseComponents/Typography/AntTypography";
import { usePrivileges } from "@portal/hooks/use-privilleges";
import useOpen from "@portal/hooks/useOpen";
import { Icon } from "@portal/lib/icons/icons";
import { useDeleteContactQuery } from "@portal/queries/contact-query";
import { userConfigAtom } from "@portal/store/userConfig/userConfig";
import { Contact_LV_UI_DTO } from "@portal/types/entities/contact";
import produce from "immer";
import { useSetAtom } from "jotai";
import { ContactSource } from "./ContactSource";
import { StyledContactItem } from "./style";

interface ContactItemProps {
  item: Contact_LV_UI_DTO;
  id: string;
}

function CustomerContactItem(props: ContactItemProps) {
  const { item, id } = props;
  const { open, handleOpenChange } = useOpen({ open: false });
  const { getContactPrivilege } = usePrivileges();
  const deleteContact = useDeleteContactQuery({ id: item.id });
  const updateConfigAtom = useSetAtom(userConfigAtom);
  function removeItem() {
    deleteContact.mutateAsync().then(() => {
      notify.success("Contact deleted successfully");
      updateConfigAtom((config) => {
        return produce(config, (draft) => {
          if (!draft.user_details) return draft;
          draft.user_details.customer.contacts =
            draft.user_details?.customer.contacts?.filter(
              (f) => f.id !== item.id
            );
          return draft;
        });
      });
    });
  }

  const Content = (
    <PopConfirmContent
      title="Confirm Delete"
      desc="Do you want to delete this Contact?"
      descStyles={{ maxWidth: "160px" }}
    />
  );

  const DeleteContact = (
    <HideWrapper
      hide={
        !getContactPrivilege("CONTACT_DELETE") ||
        item.source_app !== "CUSTOMER_PORTAL"
      }
    >
      <ToolTip title="Delete">
        <PopConfirm
          title={Content}
          onConfirm={removeItem}
          icon={false}
          cancelButtonProps={{
            type: "text",
          }}
          placement="right"
          onOpenChange={handleOpenChange}
          okText="Delete"
        >
          <Button
            type="text"
            size="small"
            icon={<Icon icon={["far", "trash-alt"]} />}
          />
        </PopConfirm>
      </ToolTip>
    </HideWrapper>
  );

  // function handleEdit() {
  //   toggleOpen();
  // }

  // const editIcon = (
  //   <HideWrapper hide={!getContactPrivilege("CONTACT_UPDATE")}>
  //     <ToolTip title="Edit">
  //       <Button
  //         type="ghost"
  //         size="small"
  //         onClick={handleEdit}
  //         icon={<Icon icon={['far','pen']} size="1x" />}
  //       />
  //     </ToolTip>
  //   </HideWrapper>
  // );

  const sourceIcon = <ContactSource sourceType={item.source_app} />;

  const contactTypeTag = (
    <>
      {/* {item?.type ? (
        <StatusTag
          text={
            contact_types_list.includes(item.type.name as ContactType)
              ? getCustomerContactConfig(item.type.name as ContactType).label
              : getCustomerContactConfig("OTHER_CONTACT").label
          }
          style={
            contact_types_list.includes(item.type.name as ContactType)
              ? getCustomerContactConfig(item.type.name as ContactType).style
              : getCustomerContactConfig("OTHER_CONTACT").style
          }
        />
      ) : null} */}
    </>
  );

  const contactInfo = (
    <Flex vertical justify="start" align="start" space={"0"}>
      <TypographyText
        fs="12"
        style={{ maxWidth: "140px" }}
        ellipsis={{ tooltip: item.email }}
      >
        {item.email}
      </TypographyText>
      <TypographyText fs="12">{item.phone_number}</TypographyText>
    </Flex>
  );

  const actionIcons = (
    <Flex space="4" justify="flex-end" style={{ paddingInline: "12px" }}>
      {DeleteContact}
      {/* {editIcon} */}
    </Flex>
  );

  return (
    <StyledContactItem id={id}>
      <Row
        align="middle"
        className="contacts-container"
        style={{ width: "100%" }}
        justify="space-between"
      >
        <Col span={6}>
          <TypographyText
            style={{ maxWidth: "110px" }}
            fs="14"
            ellipsis={{ tooltip: `${item.first_name} ${item.last_name ?? ""}` }}
          >
            {item.first_name ?? ""} {item.last_name ?? ""}
          </TypographyText>
        </Col>
        <Col span={2}>{sourceIcon}</Col>
        <Col span={5}>{contactTypeTag}</Col>
        <Col span={8}>{contactInfo}</Col>
        <Col className={open ? "" : "actions"} span={2}>
          {actionIcons}
        </Col>
      </Row>
    </StyledContactItem>
  );
}

export { CustomerContactItem };
